"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeProps = mergeProps;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
// @ts-nocheck

/**
 * Deep merge layers of props objects
 * @param  {...object} propsLayers Layers of props to merge
 * @returns {object} Merged props
 */
function mergeProps(...propsLayers) {
  return _deepmerge.default.all(propsLayers);
}
if (typeof window !== 'undefined') {
  (function (w) {
    w.ux = w.ux || {};
    w.ux.hcs = w.ux.hcs || {};
    w.ux.hcs.mergeProps = mergeProps;
  })(window);
}